import { AutomationActionType, CandidateStatus } from 'generated-graphql/types';
import { CandidateAnyStatus } from 'modules/analyse/types/CandidateAnyStatus';

export const getActionOptions = ({
  candidateStatus,
  isConnectedToAts,
  jobRecommendationsEnabled = false
}: {
  candidateStatus:
    | CandidateStatus
    | typeof CandidateAnyStatus
    | null
    | undefined;
  isConnectedToAts: boolean;
  jobRecommendationsEnabled?: boolean;
}) => {
  const actionOptions = [
    {
      label: 'Add to campaign',
      value: AutomationActionType.SendCampaign
    }
  ];

  if (jobRecommendationsEnabled) {
    actionOptions.push({
      label: 'Send job recommendations',
      value: AutomationActionType.SendJobRecommendationEmail
    });
  }

  if (
    candidateStatus &&
    candidateStatus !== CandidateAnyStatus &&
    isConnectedToAts
  ) {
    actionOptions.push({
      label: 'Update ATS',
      value: AutomationActionType.UpdateAts
    });
  }

  if (candidateStatus === CandidateStatus.Rejected) {
    actionOptions.push({
      label: 'Send an email',
      value: AutomationActionType.SendEmail
    });
  }

  return actionOptions;
};
